import { Reducer, combineReducers } from 'redux'
import { MyCourseUIState, MyCourseActionTypes } from './types'
import { IUserCourse } from '../interface'
import myCourse from '../../pages/Course/myCourse'
import { ImageUrl } from '@azure/cognitiveservices-face/esm/models'

// Type-safe initialState!
const initialState: MyCourseUIState = {
    errors: undefined,
    loading: false,
    totDoc:0,
    adding : false,
    notificed: false
}

const ui: Reducer<MyCourseUIState> = (state = initialState, action) => {
    switch (action.type) {

        case MyCourseActionTypes.FETCH_REQUEST: {
            return { ...state, loading: true}
        }
        case MyCourseActionTypes.FETCH_SUCCESS: {
            return { ...state, loading: false, totDoc: action.payload.totalDoc }
        }
        case MyCourseActionTypes.FETCH_ERROR: {
            return { ...state, loading: false, errors: action.payload.error }
        }
        case MyCourseActionTypes.CLEAR_SELECTED: {

            return { ...state, selected: undefined };
        }
        case MyCourseActionTypes.SELECT: {
            return { ...state, loading: true, selected: action.payload };
        }
        case MyCourseActionTypes.SELECTED: {
            return { ...state, loading: false };
        }
        case MyCourseActionTypes.ADD: {
            return { ...state, adding: true, addState : 0}
        }
        case MyCourseActionTypes.ADD_SUCCESS: {
            return { ...state, adding: false, addState : 1}
        }
        case MyCourseActionTypes.ADD_ERROR: {
            return { ...state, adding: false, addState : 2, errors: action.payload }
        }
        case MyCourseActionTypes.ADD_CLEAR: {
            return { ...state, adding: false, addState : 0, errors: undefined}
        }
        case MyCourseActionTypes.EDIT: {
            return { ...state, loading: true}
        }
        case MyCourseActionTypes.EDIT_SUCCESS: {
            return { ...state, loading: false}
        }
        case MyCourseActionTypes.EDIT_ERROR: {
            return { ...state, loading: false , errors: action.payload }
        }
        case MyCourseActionTypes.ASKTRAINER: {
            return { ...state, loading: true}
        }
        case MyCourseActionTypes.ASKTRAINER_SUCCESS: {
            return { ...state, loading: false}
        }
        case MyCourseActionTypes.ASKTRAINER_ERROR: {
            return { ...state, loading: false , errors: action.payload }
        }
        case MyCourseActionTypes.NOTIFIED: {
            return { ...state, notificed : true };
        }
        default: {
            return state
        }
    }
}


const byId: Reducer<{}> = (state = {}, action) => {

    switch (action.type) {
        case MyCourseActionTypes.FETCH_SUCCESS: {

            // console.log("byid : " + state) ;
            // var _temp: any = {};
            // action.payload.forEach((item: Course) => {
            //     _temp[item.id] = item;
            // });
            // return { ...state, ..._temp };

            // Check before combine
            // const currentStateList:any = {...state};
            // var _temp: any = {};
            // action.payload.forEach((item: Course) => {
            //     if(currentStateList[item.id] === undefined)
            //     {
            //         _temp[item.id] = item;
            //         //results.push(item.id);
            //     }
            // });
            //return { ...state, ..._temp };

            // Return new result set
            var _temp: any = {};
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                if (action.payload.offset == 0){ 
                    // Reset initial search
                    action.payload.doc.forEach((item: IUserCourse) => {
                        _temp[item.id] = item;
                    });
                    return _temp;
                }
                else
                {
                    // Combine if load more
                    const currentStateList:any = {...state};
                    action.payload.doc.forEach((item: IUserCourse) => {
                        if(currentStateList[item.id] === undefined)
                        {
                            _temp[item.id] = item;
                            //results.push(item.id);
                        }
                    });
                    return { ...state, ..._temp };
                }
            }else{
                return _temp;
            }
        }
        case MyCourseActionTypes.ADD_SUCCESS:
        case MyCourseActionTypes.EDIT_SUCCESS: {
            // return {
            //     //...state, [action.payload.doc.id]: action.payload.doc
            //     ...state, ...action.payload
            // }
            let id = action.payload.id;
            const currentStateList:any = {...state};
            currentStateList[id] = action.payload;
            return currentStateList;
        }
        default: {
            return state
        }
    }
}

//const allIds: Reducer<number[]> = (state = [], action) => {
const allIds: Reducer<string[]> = (state = [], action) => {
    //console.log("Action Payload:" + action.payload);
    switch (action.type) {
        case MyCourseActionTypes.FETCH_SUCCESS: {

            // (1) This will keed append even though same id exists
            //return state.concat(...action.payload.map((item: Course) => item.id));

            // (2) Check if result exists then only combine
            // const results =[...state];
            // action.payload.forEach((item: Course) => {
            //     if(results.some((s)=>s === item.id)===false)
            //     {
            //         results.push(item.id);
            //     }
            // });
            // return results;

            // (3) Return new result only
            // var results:any =[];
            // if (action.payload.isSuccess && action.payload.totalDoc > 0){  
            //     results = action.payload.doc.map((item: Course) => item.id);
            //     console.log(results);
            // }

            // (4) Return new result for initial search, load more append
            
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                if (action.payload.offset ==0){
                    var results:any =[];
                    results = action.payload.doc.map((item: IUserCourse) => item.id);
                    return results;
                }else{
                    const results =[...state];
                    action.payload.doc.forEach((item: IUserCourse) => {
                        if(results.some((s)=>s === item.id)===false)
                        {
                            results.push(item.id);
                        }
                    });
                    return results;
                }
                //console.log(results);
            }else{
                var results:any =[];
                return results;
            }
        }
        case MyCourseActionTypes.ADD_SUCCESS: {
            return [
                ...state, action.payload.id
            ]
        }
        default: {
            return state
        }
    }
}
//
const byCategory: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        case MyCourseActionTypes.FETCH_SUCCESS: {
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                const result:any[] = action.payload.doc.reduce(function (r:any, a:any) {
                    r[a.courseYear] = r[a.courseYear] || [];
                    r[a.courseYear].push(a.id);
                    return r;
                }, Object.create(null));
                return result;
            }
            else{
                const result:any[] = [];
                return result;
            }
        }
        // case MyCourseActionTypes.ADD_SUCCESS: {
        //     //const result:any[] = {...state};
        //     result[action.payload.courseYear].push(action.payload.id)
            
        //     return result;
        // }
        default: {
            return state
        }
    }
}

const Category: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        case MyCourseActionTypes.FETCH_SUCCESS:
        case MyCourseActionTypes.ADD_SUCCESS:
        {
            const results =[...state];
            
            // if (action.payload.isSuccess && action.payload.totalDoc > 0){  
            //     action.payload.doc.forEach((item: MyCourse) => {
            //         if(results.some((s)=>s === item.status)===false)
            //         {
            //             results.push(item.status);
            //         }
            //     });
            // }
            return results;
        }
        default: {
            return state
        }
    }
}


// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const MyCourseReducer = combineReducers({
    ui,
    byId,
    allIds,
    byCategory,
    Category
})
export default MyCourseReducer
